export const setUser = (user, token) => {
  return dispatch => {
    dispatch({ type: 'SET_USER', user, token });
  };
};
